import { render } from "./ExtractComponent.vue?vue&type=template&id=41bf872e&scoped=true"
import script from "./ExtractComponent.vue?vue&type=script&lang=js"
export * from "./ExtractComponent.vue?vue&type=script&lang=js"

import "./ExtractComponent.vue?vue&type=style&index=0&id=41bf872e&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41bf872e"]])

export default __exports__